import { UserPreferenceKeys } from "./userPreferencesSlice";

import { LOCALSTORAGE_PREFIX } from "@/features/app/constants";
import { safeLocalStorage } from "@/features/utils/utils";

const USER_PREFERENCE_STORAGE_KEYS = Object.values(UserPreferenceKeys);

export const clearStoredUserPreferences = () => {
  USER_PREFERENCE_STORAGE_KEYS.forEach((key) => {
    safeLocalStorage.removeItem(`${LOCALSTORAGE_PREFIX}${key}`);
  });
};
